<template>
  <ProgressCircular v-if="loading" />
  <v-form
    v-else
    novalidate
    ref="updateRouteForm"
    :disabled="disabled"
    @submit.prevent="() => {}"
  >
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200" flat color="transparent">
          <v-card-title class="mb-10">
            <FormHeader
              :loading="loading"
              :disabled="disabled"
              :link="'page-routes'"
              :title="getTitle ? `${getTitle} маршрут` : `Создать маршрут`"
            />
          </v-card-title>
          <v-tabs v-model="activeTab">
            <v-tab v-for="tab in $options.tabs" :key="tab.value" :disabled="disabled">
              {{ tab.title }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item>
              <v-card-text>
                <PageContent>
                  <v-container>
                    <InputTitleSlug
                      id-title="title"
                      :is-loading="loading || disabled"
                      :title="fields.title"
                      :title-error="validationErrors.title"
                      :slug="fields.slug"
                      :slug-error="validationErrors.slug"
                      :isSlugEnabled="!isNew"
                      @change:title="fields.title = $event"
                      @change:slug="fields.slug = $event"
                      @input:slug="$v.fields.slug.$touch"
                    />
                    <v-row>
                      <span>Описание* (<TranslationIcon />)</span>
                      <QuillEditorVue
                        id="description"
                        :cols="12"
                        :title="''"
                        :disabled="disabled"
                        :content="fields.description"
                        :isShowErrorMessage="true"
                        :errorText="validationErrors.description"
                        light-mode
                        @input="fields.description = $event"
                        @onChangeContent="$emit('change:descriptionForMobile', { fields, $event })"
                      />
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <MediaFilePicker
                          label="Изображения"
                          :file-type="$options.mediaTypesByKeys.IMAGE"
                          :value="fields.images"
                          @change="fields.images = $event"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <SeoSettings
                          :data="data"
                          :loading="loading || disabled"
                          @on-input-seo="fields = Object.assign({}, fields, $event)"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </PageContent>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <PageContent>
                  <DynamicListWrapper
                    :multiple-creating="false"
                    :list="fields.points"
                    :error-messages="mixValidationErrors"
                    :available-items="$options.availablePoints"
                    :copy-clipboard="mixCopyListItemClipboard"
                    :options="$options.options"
                    @list-sort="mixListItemsReassort"
                    @add="mixCreateListItemHandler"
                    @option="mixListItemOptionHandler"
                    @option-manual="optionPointHandler"
                  >
                    <template #item="{ data }">
                      <component
                        :is="data.item.type"
                        :list-item="data.item"
                        :error-messages="mixDynamicListValidationErrors[data.itemIndex]"
                        @change="mixListItemChangeHandler($event, data.itemIndex)"
                        @change-item="
                          mixListItemChangeItemHandler($event, data.itemIndex)
                        "
                        @remove-item="
                          mixListItemRemoveItemHandler($event, data.itemIndex)
                        "
                      />
                    </template>
                  </DynamicListWrapper>
                </PageContent>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
      <v-col cols="4" ref="sideBar">
        <ManageSidePanel
          ref="manageSidePanel"
          isShowSortOrder
          :is-new="!getId"
          :created-at="createdAt"
          :updated-at="updatedAt"
          :published-at="publishedAt"
          :is-loading="loading || disabled"
          :language="language"
          :translations="fields.translations"
          :entity-id="getId"
          :entity-type="'route'"
          :sortOrder="fields.sortOrder"
          @delete="$emit('delete-route')"
          @cancel="$router.push({ name: 'page-routes' })"
          @submit="submit"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
          @update-sort-order="fields.sortOrder = Number($event)"
        >
          <template #info-append>
            <StatusPicker
              align="center"
              cols="12"
              title="Статус:"
              :disabled="disabled"
              :loading="loading"
              :status="fields.status"
              @status:change="fields.status = $event"
            />
            <v-row v-if="!isNew" align="center">
              <v-col cols="6">
                <span>Посмотреть на сайте</span>
              </v-col>
              <v-col cols="6">
                <v-btn
                  icon
                  link
                  color="primary"
                  target="_blank"
                  :href="redirerectToWebPortal"
                  :loading="loading"
                  :disabled="disabled"
                  ><v-icon>mdi-web</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </template>
          <template #body>
            <v-card flat>
              <v-card-subtitle class="grey--text"> Связи </v-card-subtitle>
              <v-card-text>
                <v-row no-gutters>
                  <!-- <v-col>
                    <span>Тип автора*</span>
                    <v-select
                      id="profileType"
                      dense
                      outlined
                      no-data-text="Список пуст"
                      item-value="value"
                      item-text="title"
                      clearable
                      :items="$options.profiles"
                      :loading="loading"
                      :disabled="disabled"
                      :error-messages="validationErrors.profileType"
                      v-model="fields.profileType"
                    />
                  </v-col> -->
                </v-row>
                <v-row no-gutters>
                  <!-- <v-col>
                    <span>Автор*</span>
                    <template v-if="!!fields.profileId">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="primary"
                            @click="$refs.profileForm.open()"
                          >
                            <v-icon>mdi-card-account-details</v-icon>
                          </v-btn>
                        </template>
                        <span>Посмотреть информацию о партнере</span>
                      </v-tooltip>
                    </template>
                    <v-select
                      id="profileId"
                      dense
                      outlined
                      no-data-text="Выберите тип автора"
                      item-value="id"
                      item-text="name"
                      clearable
                      :items="fields.profileType ? profiles[fields.profileType] : []"
                      :loading="loading"
                      :disabled="disabled"
                      :error-messages="validationErrors.profileId"
                      v-model="fields.profileId"
                    />
                  </v-col> -->
                </v-row>
                <v-row no-gutters v-if="!!events">
                  <v-col>
                    <span>Событие</span>
                    <v-autocomplete
                      dense
                      outlined
                      clearable
                      no-data-text="Список пуст"
                      placeholder="Начните вводить для поиска..."
                      item-value="id"
                      item-text="title"
                      :items="events"
                      :value="fields.eventId"
                      :loading="loading"
                      :disabled="disabled"
                      @change="fields.eventId = $event"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col v-if="!!cities">
                    <span>Город</span>
                    <v-select
                      dense
                      outlined
                      no-data-text="Список пуст"
                      item-value="id"
                      item-text="title"
                      clearable
                      :value="fields.cityId"
                      :items="cities"
                      :loading="loading"
                      :disabled="disabled"
                      @change="fields.cityId = $event"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <span>Виды передвижения *</span>
                    <v-select
                      id="modes"
                      dense
                      outlined
                      no-data-text="Список пуст"
                      item-value="id"
                      item-text="label"
                      multiple
                      :error-messages="validationErrors.modes"
                      :value="fields.modes"
                      :loading="loading"
                      :disabled="disabled"
                      :items="dictionariesTypes.routeMode"
                      @change="fields.modes = $event"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <span>Категории маршрута *</span>
                    <v-select
                      id="categories"
                      dense
                      outlined
                      no-data-text="Список пуст"
                      item-value="id"
                      item-text="label"
                      multiple
                      :loading="loading"
                      :disabled="disabled"
                      :error-messages="validationErrors.categories"
                      :value="fields.categories"
                      :items="dictionariesTypes.routeCategory"
                      @change="fields.categories = $event"
                    />
                  </v-col>
                </v-row>
                <Organizer
                  :profileType="fields.profileType"
                  :profileId="fields.profileId"
                  :profileTypeError="validationErrors.profileType"
                  :loading="loading"
                  :disabled="disabled"
                  :allowedProfilesProps="['GUIDE', 'TOURIST_AGENCY']"
                  @input:profile-type="fields.profileType = $event"
                  @input:profile-id="fields.profileId = $event"
                />
              </v-card-text>
            </v-card>
          </template>
        </ManageSidePanel>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { defaultDateFormat } from '@/configs/date.js'
import FormAbstract from '@/components/abstract/form'
import validationRules from './validation-rules'
import ManageSidePanel from '@/components/manage-side-panel'
import { pointsList } from '@/utils/widgets'
import parentDynamicList from '@/mixins/dynamic-list/parentDynamicList.mix.js'
import pointsParentMix from '@/mixins/points/pointsParent.mix.js'
import prepareTranslations from '@/mixins/translations/prepareTranslations.mix'
import DynamicListWrapper from '@/components/dynamic-list-wrapper/DynamicListWrapper.vue'
import MediaFilePicker from '@/components/media-file-picker/MediaFilePicker.vue'
import Geolocation from '@/utils/types/Geolocation.js'
import SeoSettings from '@/components/seo-settings'
import { RoutePoint } from '@/utils/widgets/widgetsTypes'
import Widget from '@/utils/widgets/Widget'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import validationTranslations from '@/mixins/translations/validationTranslations.mix.js'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import FormHeader from '@/components/form-header'
import InputTitleSlug from '@/components/inputs/InputTitleSlug'
import QuillEditorVue from '@/components/quill-editor'
import { mixForm } from '@/utils/form.mix.js'
import profiles from '@/configs/profiles'
import StatusPicker from '@/components/status-picker'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'
import Organizer from '@/components/organizer'

const tabs = [
  {
    title: 'Основное',
    value: 'main'
  },
  {
    title: 'Точки',
    value: 'points'
  }
]

export default {
  name: 'FormRoute',
  tabs,
  profiles,
  defaultDateFormat,
  validationRules,
  mediaTypesByKeys: mediaTypesByKeys(),
  availablePoints: pointsList,
  dynamicListName: 'points',
  extends: FormAbstract,
  mixins: [
    parentDynamicList,
    pointsParentMix,
    validationTranslations,
    prepareTranslations,
    mixForm
  ],
  components: {
    PageContent,
    InputTitleSlug,
    TranslationIcon,
    ManageSidePanel,
    DynamicListWrapper,
    MediaFilePicker,
    SeoSettings,
    FormHeader,
    QuillEditorVue,
    StatusPicker,
    ProgressCircular,
    Organizer
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    dictionaries: {
      type: Array,
      default: () => []
    },
    cities: {
      type: Array,
      default: () => []
    },
    events: {
      type: Array,
      default: null
    },
    language: {
      type: String,
      default: null
    },
    isNew: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeTab: 0,
      fields: {
        title: null,
        slug: undefined,
        status: null,
        description: '',
        modes: [],
        categories: [],
        points: [],
        images: [],
        cityId: null,
        profileId: null,
        profileType: null,
        seoMetaTitle: null,
        seoMetaDescription: null,
        seoDisallowIndex: false,
        seoMetaKeywords: null,
        seoRelCanonical: null,
        seoOgImage: null,
        eventId: null,
        translations: { ru: { isEnabled: true } },
        sortOrder: null
      },
      dictionariesTypes: {
        routeMode: [],
        routeCategory: []
      },
      postActions: {
        itemsToRemove: []
      },
      profiles: {
        TOURIST_AGENCY: [],
        GUIDE: []
      }
    }
  },
  computed: {
    redirerectToWebPortal () {
      if (this.data) {
        const { slug } = this.data
        return window.location.href.includes('demo')
          ? `${process.env.VUE_APP_WEB_PORTAL_URL_DEMO}/routes/${slug}`
          : `${process.env.VUE_APP_WEB_PORTAL_URL}/routes/${slug}`
      }
      return '#'
    },
    getTitle () {
      if (this.data) {
        return this.data?.title || ''
      }
      return null
    },
    validationRulesVars () {
      return { id: this.data?.id, ctx: this, isNew: this.isNew }
    },
    getId () {
      return this?.data?.id || null
    },
    createdAt () {
      return this?.data?.createdAt || null
    },
    updatedAt () {
      return this?.data?.updatedAt || null
    },
    publishedAt () {
      return this?.data?.publishedAt || null
    }
  },
  watch: {
    data (data) {
      this.populate(data)
      this.fields.categories = data?.categories.map(c => c.id)
      this.fields.cityId = data?.city?.id
      this.fields.modes = data?.modes.map(c => c.id)
      this.fields.type = data?.type?.id
      this.fields.eventId = data?.event?.id || null
      this.preparePoints(data.points)
      this.prepareImages(data.images)
    },
    dictionaries (nevVal) {
      this.prepareDictionaries(nevVal)
    }
  },
  methods: {
    resetPostActions () {
      this.postActions.itemsToRemove = []
    },
    optionPointHandler ({ value }, itemIndex, item) {
      // TODO: attention! hardcoded value in the cases
      switch (value) {
        case 'delete':
          this.postActions.itemsToRemove.push(item.data.id)
          this.mixListItemRemoveItem(itemIndex)
          break
      }
    },
    prepareImages (images) {
      this.fields.images = images.map(image => image.id)
    },
    prepareDictionaries (list) {
      for (const type in this.dictionariesTypes) {
        const { options } = list.find(item => item.name === type) ?? {}
        this.dictionariesTypes[type] = options || []
      }
    },
    preparePoints (points) {
      this.fields.points = points.map(point => {
        const preparedPoint = {
          data: { ...point }
        }
        preparedPoint.data.images = point.images.map(image => image.id)
        preparedPoint.data.location = new Geolocation(point.location)
        return Widget.populate(preparedPoint, RoutePoint)
      })
    },
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      const postActions = { ...this.postActions }
      this.resetPostActions()
      if (!this.mixIsValidTranslations(this.fields.translations)) {
        this.$errorMsg('Не выбран ни один язык для контента!')
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }
      delete payload.seoOgImage
      this.mixPrepareTranslations(payload)
      if (!payload.profileType) delete payload.profileType
      if (!payload.profileId) delete payload.profileId
      const isWidgetsInValid = this.mixValidateDynamicList(payload.points)
      if (!isWidgetsInValid) {
        this.$emit('submit', {
          data: payload,
          postActions
        })
      } else {
        this.$errorMsg('Не заполнены обязательные поля точек!')
      }
    }
  },
  mounted () {
    this.prepareDictionaries(this.dictionaries)
  }
}
</script>
